import { Component, Input } from "@angular/core";
import { EButtonType } from "../../../data-types/button.enum";
import { iconsLibrary } from "../../../../theme/constants";
import { EFooterStyleInput } from "../../../data-types/footer.enum";

declare var window;
@Component({
  selector: "cowing-footer",
  templateUrl: "./cowing-footer.component.html",
  styleUrls: ["./cowing-footer.component.scss"],
})
export class CowingFooterComponent {
  @Input("type") type: EFooterStyleInput = EFooterStyleInput.Primary;

  public get getLinkedinIcon() {
    if (this.type === EFooterStyleInput.Secondary)
      return `${iconsLibrary.linkedinBlue}`;
    return `${iconsLibrary.linkedin}`;
  }

  public get getEmailIcon() {
    if (this.type === EFooterStyleInput.Secondary)
      return `${iconsLibrary.emailBlue}`;
    return `${iconsLibrary.email}`;
  }

  public navToPage(page) {
    window.open(page, "_blank");
  }
}
